import { useEffect, useState } from 'react';
// material
import { Button, Container } from '@material-ui/core';
import { Icon } from '@iconify/react';
import backFill from '@iconify/icons-eva/arrow-back-fill';
// eslint-disable-next-line import/no-unresolved
import AddUserRoleForm from 'src/components/_dashboard/usermanagement/AddUserRoleForm';
// eslint-disable-next-line import/no-unresolved
import UserRoleList from 'src/components/_dashboard/usermanagement/UserRoleList';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getUserRoleList, getAllModuleList } from '../../redux/slices/user_role';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';

// ----------------------------------------------------------------------

export default function UserRole() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { userRoleList, disableUserRoleList, isLoading, moduleList } = useSelector((state) => state.user_role);
  const [editId, setEditId] = useState('');
  const [deleteId, setDeleteId] = useState('');
  const [userRoleListStatus, setUserRoleListStatus] = useState(true);
  const [visibleComponent, setVisibleComponent] = useState('List');
  const [currentUserRole, setCurrentUserRole] = useState({});

  useEffect(() => {
    dispatch(getUserRoleList(true));
    dispatch(getUserRoleList(false));
    dispatch(getAllModuleList());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getUserRoleList(userRoleListStatus));
  }, [userRoleListStatus]);

  useEffect(() => {
    setVisibleComponent('List');
  }, []);

  useEffect(() => {
    if (editId) {
      setVisibleComponent('Edit');
      const tempUserRole = userRoleList.find((user) => user.id === editId);
      setCurrentUserRole(tempUserRole);
    } else setVisibleComponent('List');
  }, [editId]);

  useEffect(() => {
    if (visibleComponent !== 'Edit') setEditId('');
  }, [visibleComponent]);

  const setComponentList = (e) => {
    setVisibleComponent('List');
    e.preventDefault();
  };

  return (
    <Page title="User Role | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading="User Role"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            {
              name: 'User Role',
              href: PATH_DASHBOARD.general.user_role,
              handleClick: (e) => {
                setComponentList(e);
              }
            },
            { name: `${visibleComponent} Role` }
          ]}
          action={
            visibleComponent === 'List' ? (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('Add');
                }}
              >
                Add Role
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={() => {
                  setVisibleComponent('List');
                }}
                startIcon={<Icon icon={backFill} />}
              >
                List
              </Button>
            )
          }
        />
        {visibleComponent === 'Add' && <AddUserRoleForm setVisibleComponent={setVisibleComponent} />}
        {visibleComponent === 'List' && (
          <UserRoleList
            userRoleListStatus={userRoleListStatus}
            setUserRoleListStatus={setUserRoleListStatus}
            userRoleList={userRoleListStatus ? userRoleList : disableUserRoleList}
            setEditId={setEditId}
            deleteId={deleteId}
            setDeleteId={setDeleteId}
            loading={isLoading}
          />
        )}
        {visibleComponent === 'Edit' && (
          <AddUserRoleForm
            setVisibleComponent={setVisibleComponent}
            currentUserRole={currentUserRole}
            editId={editId}
            // moduleList={moduleList}
          />
        )}
      </Container>
    </Page>
  );
}
